import { useMutation, useQueryClient } from "@tanstack/react-query";
import { terminalInventoryKeys } from "Api/Queries/TerminalInventory/useTerminalInventoryListQuery";
import { putTerminalInventoryPublicIDShip } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useShipTerminalMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      putTerminalInventoryPublicIDShip(publicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: terminalInventoryKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
